import { FETCH_STATUSES, FETCH_STATUS_IDLE } from './constants';
import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import scoreAPI from './scoreAPI';

/**
 * @TODO rename to scores ?
 * Needs a 'partial'-loaded status
 */

export const fetchMyScoreList = createAsyncThunk(
  'myScoreList/fetchMyScoreListStatus',
  async () => {
    const response = await scoreAPI.fetchMyScoreList();
    return response;
  }
)

const scoresAdapater = createEntityAdapter({})

export const myScoreListSlice = createSlice({
  name: 'myScoreList',
  initialState: scoresAdapater.getInitialState({
    status: FETCH_STATUSES.IDLE,
    error: ''
  }),
  reducers: { },
  extraReducers(builder) {
    builder
      .addCase(fetchMyScoreList.pending, (state, action) => {
        state.status = FETCH_STATUSES.PENDING
      })
      .addCase(fetchMyScoreList.fulfilled, (state, action) => {
        state.status = FETCH_STATUSES.FULFILLED
        scoresAdapater.addMany(state, action.payload);
      })
      .addCase(fetchMyScoreList.rejected, (state, action) => {
        state.status = FETCH_STATUSES.FAILED
        state.error = action.error.message
      })
  }
});

const globalizedSelectors = scoresAdapater.getSelectors((state) => state.myScoreList)

export const selectScores = globalizedSelectors.selectAll;

export default myScoreListSlice.reducer;